import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import * as periodoService from "../../services/periodoService";
import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';
import Period from '../../components/Period'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import {activeValidations as activeValidationsPeriod} from "../../redux/periodSlice";

const Edit = (props) => {
   const period = useSelector((state) => state.period.entity);
   const periodValidation = useSelector((state) => state.period.validationMessage);
   // Periodos Academicos del detalle: en un periodo nuevo son los pendientes.
   const periodoDetalle = useSelector((state) => state.period.listPeriodoDetalle);

  const [openMessage, setOpenMessage] = useState(false)
  const onCloseMessage = () => { setOpenMessage(!openMessage); }
  const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const { isReadOnly, setIsReadOnly } = useMantenimiento("periodo");
  // Se incrementa al guardar para que el formulario vuelva a traer el periodo del
  // API y se vea el codigo que genero.
  const [refreshKey, setRefreshKey] = useState(0);
  const postEntity = async () => {
    // El detalle de periodos Academicos va con el periodo: en un periodo nuevo
    // el API todavia no tiene id, asi que los Academicos que se elegieron se
    // envian aqui y se guardan junto con el periodo.
    var dataPost = {
      ...period,
      periodoDetalle: (periodoDetalle || []).map((row) => ({
        id: row.id,
        idPeriodo: 0,
        idPeriodoDetalleRef: row.idPeriodoDetalleRef,
        observaciones: "",
      }))
    }

    var ValidationMessages = periodValidation;

    if (ValidationMessages.length > 0) {
      setPropsMessage({ severity: "error", message: ValidationMessages.join(" - ") })
      dispatch(activeValidationsPeriod());
      setOpenMessage(true);
    }
    else {
      await periodoService.addUpdatePeriodo(dataPost)
        .then(response => {
          setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
          setOpenMessage(true);
          setIsReadOnly(true);

          // Si era un periodo nuevo, el API devuelve el id que le dio. La pantalla
          // pasa a ese id para mostrar lo guardado, incluido el codigo que genero.
          const idGuardado = response?.data?.data;

          if (parseInt(params.id) === 0 && idGuardado > 0) {
            navigate("/period/edit/" + idGuardado, { replace: true });
          }

          setRefreshKey((valor) => valor + 1);
        })
        .catch(error => {
          setPropsMessage({ severity: "error", message: "Hubo un error" })
          setOpenMessage(true);
        });
    }
  }

  return (
    <div>
      <MantenimientoForm
        title={(params.id == 0 ? "Nuevo" : "Editar") + " Periodo"}
        backTo={"/period"}
        onSave={postEntity}
        disabled={isReadOnly}
      >
        <Grid container spacing={1} sx={{
          "& .MuiGrid-root>.MuiGrid-item": {
            paddingTop: "8px"
          },
        }}>
          <Grid item xs={12} sm={12}>
            <Card >
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <Period isReadOnly={isReadOnly} refreshKey={refreshKey} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MantenimientoForm>
      <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
        anchorOrigin={{vertical: "top", horizontal: "center"}}>
        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
          {propsMessage.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Edit